import { Grid } from '@mui/material';
import { Notes, ProceedSaveLater, SubHeading } from './components';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import MFSelectField from '../../lib/formik/SelectField';
import {
  Applicant,
  ApplicationProps,
  Broker,
  BrokerList,
  DPNameType,
} from '../../redux-store/types/api-types';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  CKYC_SELECTION_OPTIONS_OBJECT,
  DematDetialsValidationModified,
  DLCLMasters,
  occupationDetailsMasters,
  otherOccupationStartDate,
  PAN_AADHAAR_MASTER,
  PEPsMasters,
  SOURCE_OF_FUNDS_MASTER,
  USER_ROLES,
  YES_NO_BOOLEAN_MASTER,
  YES_NO_MASTER,
} from '../../utils/constant';
import {
  // eslint-disable-next-line
  allowOnlyNumbers,
  applicationComparison,
  applyRoleBasedStatus,
  checkApplicantResident,
  clearclIdField,
  cleardpIdField,
  getApplicantName,
  getPanAadhaarMasterBasedOnstatus,
  getclIdField,
  getdpIdField,
  isAmcCallVerified,
  isCkycMandatory,
  isFirstApplicant,
  isOtherSourceOfFund,
  isValidPEP,
  saveForLater,
  statusRoleBased,
  isCDSL,
  dlclIdFieldMandatory,
  checkValidationBasedOnDate,
  getGrossAnnualMasters,
  isOtherOccupation,
  getOlderDate,
} from '../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useEffect, useState } from 'react';
import { updateApplication } from '../../redux-store/actions/application';
import { useHistory } from 'react-router';
import { KYCDetailsSchema } from '../../utils/schema';
import { MFTextField } from '../../lib/formik';
import { useSnackbar } from 'notistack';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import UseRadioGroup from '../../lib/formik/Radio';
import { showError } from '../../redux-store/actions/auth';
import { useFeatureToggles, useMdmsBrokerListData } from '../../utils/useDataMdms';
import { getDPNameList } from '../../redux-store/actions/userManagement';

export type Values = {
  applicants: Partial<Applicant & { otherSourceOfFunds: string; applicant_type: string }>[];
  saveType: string;
};

export const ckycDeclaration = 'Proof of CKYC document is to be uploaded';

const initialValues: Values = {
  applicants: [
    {
      occupationDetails: '',
      grossAnnualIncome: '',
      politicallyExposedPersonStatus: 'Not Applicable',
      ckycNo: '',
      dlclId: dlclIdFieldMandatory() ? '' : 'none',
      dpId: '',
      clId: '',
      nameOfBroker: '',
      dematName: '',
      amcCallVerified: '',
      sourceOfFunds: '',
      otherSourceOfFunds: '',
      dataFetchedFromKRA: null,
      panAadhaarLinked: '',
      ckyc_selection_options: '',
      otherOccupationDetails: '',
      applicant_type: '',
      broker_id: null,
    },
  ],
  saveType: 'save and proceed',
};
export const DematDetails = ({
  index,
  values,
  brokers,
  createdAt,
  dpBroker,
}: {
  index: number;
  values: Values;
  brokers: Broker[];
  createdAt: string;
  dpBroker: DPNameType[];
}): JSX.Element => {
  const { application } = useSelector((store: RootStateType) => store.application);
  return (
    <>
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`applicants.${index}.dlclId`}
          label="Demat Account Details (for allotment of units) *"
          items={Object.keys(DLCLMasters).map((Id) => ({
            key: DLCLMasters[Id],
            value: Id,
          }))}
        />
        {cleardpIdField(values.applicants[index].dlclId || '') && (
          <Notes displayContent={'Approver document to be uploaded'} />
        )}
      </Grid>
      {getdpIdField(values.applicants[index].dlclId || '') && (
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`applicants.${index}.dpId`}
            label={`${
              isCDSL(values.applicants[index].dlclId || '') &&
              !checkValidationBasedOnDate(createdAt, DematDetialsValidationModified)
                ? 'DPCL ID'
                : 'DP ID'
            } *`}
            placeholder={`Enter ${
              isCDSL(values.applicants[index].dlclId || '') &&
              !checkValidationBasedOnDate(createdAt, DematDetialsValidationModified)
                ? 'DPCL ID'
                : 'DP ID'
            }`}
            inputProps={{ style: { textTransform: 'uppercase' } }}
          />
        </Grid>
      )}
      {getclIdField(values.applicants[index].dlclId || '', createdAt) && (
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`applicants.${index}.clId`}
            label="CL ID *"
            placeholder="Enter CL ID"
          />
        </Grid>
      )}
      {/* {getdpIdField(values.applicants[index].dlclId || '') && (
        <Grid item xs={12} sm={6}>
          <SearchableSelect
            name={`applicants.${index}.nameOfBroker`}
            label="Name of Broker/Depository Participant (DP)"
            items={brokers?.map((broker: Broker) => ({
              key: broker.value,
              value: broker.key,
            }))}
            searchFieldPlaceholder={'Search Broker/Depository Participant'}
          />
        </Grid>
      )} */}
      {getdpIdField(values.applicants[index].dlclId || '') && (
        <Grid item xs={12} sm={6}>
          <SearchableSelect
            name={`applicants.${index}.broker_id`}
            label="Name of Broker/Depository Participant (DP)"
            items={dpBroker
              .filter(
                (broker) =>
                  broker?.isActive || broker?.id == application?.applicants[index]?.broker_id
              )
              .map((broker: DPNameType) => ({
                value: Number(broker.id),
                key: broker.brokerName ?? '',
              }))}
            searchFieldPlaceholder="Search Broker/Depository Participant"
          />
        </Grid>
      )}
      {getdpIdField(values.applicants[index].dlclId || '') && (
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`applicants.${index}.dematName`}
            label={`Name as per the Demat Account *`}
            placeholder="Enter name as per the demat account"
          />
        </Grid>
      )}
    </>
  );
};

const KYCDetails = ({
  applicant,
  index,
  values,
  brokers,
  ifTopUp,
  dpBroker,
}: {
  applicant: string;
  index: number;
  values: Values;
  brokers: Broker[];
  ifTopUp: boolean;
  dpBroker: DPNameType[];
}): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { applicants = [] } = application || {};
  return (
    <>
      <SubHeading>Additional KYC Details of {applicant} Applicant</SubHeading>
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`applicants.${index}.occupationDetails`}
          label="Occupation Details *"
          items={occupationDetailsMasters.map((occupation) => ({
            key: occupation,
            value: occupation,
          }))}
          disabled={ifTopUp}
        />
      </Grid>
      {checkValidationBasedOnDate(application?.createdAt || '', otherOccupationStartDate) &&
        isOtherOccupation(values.applicants[index].occupationDetails || '') && (
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.otherOccupationDetails`}
              label={`Please specify other occupation *`}
              placeholder={'Enter other occupation'}
            />
          </Grid>
        )}
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`applicants.${index}.grossAnnualIncome`}
          label="Gross Annual Income *"
          items={getGrossAnnualMasters(application?.createdAt || '').map((grossIncome) => ({
            key: grossIncome,
            value: grossIncome,
          }))}
          disabled={ifTopUp}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`applicants.${index}.politicallyExposedPersonStatus`}
          label="Politically Exposed Person (PEP) Status *"
          items={PEPsMasters.map((pep) => ({ key: pep, value: pep }))}
          disabled={ifTopUp}
        />
        {isValidPEP(values.applicants[index].politicallyExposedPersonStatus || '') && (
          <Notes displayContent={'PEP document to be uploaded'} />
        )}
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        sx={{ '.MuiFormControl-root': { marginBottom: '2px', marginTop: '16px' } }}>
        <UseRadioGroup
          formLabel={`Ckyc selection options *`}
          name={`applicants.${index}.ckyc_selection_options`}
          items={Object.keys(CKYC_SELECTION_OPTIONS_OBJECT).map((option) => ({
            label: CKYC_SELECTION_OPTIONS_OBJECT[option],
            value: option,
          }))}
        />
        {!isCkycMandatory(values.applicants[index].ckyc_selection_options || '') && (
          <Notes displayContent={ckycDeclaration} />
        )}
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.ckycNo`}
          label={`CKYC Number${
            isCkycMandatory(values.applicants[index].ckyc_selection_options || '') ? ' *' : ''
          }`}
          placeholder={'Enter CKYC number'}
          disabled={[USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role) || ifTopUp}
        />
      </Grid>
      <DematDetails
        index={index}
        values={values}
        brokers={brokers}
        createdAt={application?.createdAt || ''}
        dpBroker={dpBroker}
      />
      {isFirstApplicant(applicants[index]?.applicant_type || '') && (
        <Grid
          item
          xs={12}
          sm={6}
          sx={{ '.MuiFormControl-root': { marginBottom: '2px', marginTop: '16px' } }}>
          <UseRadioGroup
            formLabel="AMC call verified? *"
            name={`applicants.${index}.amcCallVerified`}
            items={Object.keys(YES_NO_MASTER).map((option) => ({
              label: YES_NO_MASTER[option],
              value: option,
            }))}
          />
          {isAmcCallVerified(values.applicants[index].amcCallVerified || '') && (
            <Notes displayContent={'AMC call waiver document to be uploaded'} />
          )}
        </Grid>
      )}
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`applicants.${index}.sourceOfFunds`}
          label="Source Of Funds"
          items={Object.keys(SOURCE_OF_FUNDS_MASTER)?.map((item: string) => ({
            key: SOURCE_OF_FUNDS_MASTER[item],
            value: item,
          }))}
          disabled={ifTopUp}
        />
        {values.applicants[index]?.sourceOfFunds && (
          <Notes displayContent={'Relevant source of fund document to be uploaded'} />
        )}
      </Grid>
      {values.applicants[index]?.sourceOfFunds &&
        isOtherSourceOfFund(values.applicants[index]?.sourceOfFunds || '') && (
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.otherSourceOfFunds`}
              label="Please Specify Other Source Of Funds *"
              placeholder="Enter other source of funds"
            />
          </Grid>
        )}
      <Grid
        item
        xs={12}
        sm={6}
        sx={{ '.MuiFormControl-root': { marginBottom: '2px', marginTop: '16px' } }}>
        <UseRadioGroup
          formLabel="KYC Compliant *"
          name={`applicants.${index}.dataFetchedFromKRA`}
          items={Object.keys(YES_NO_BOOLEAN_MASTER).map((option) => ({
            label: YES_NO_BOOLEAN_MASTER[option],
            value: option,
          }))}
          disabled={true}
          value={values.applicants[index].dataFetchedFromKRA?.toString()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        sx={{ '.MuiFormControl-root': { marginBottom: '2px', marginTop: '16px' } }}>
        <UseRadioGroup
          formLabel="PAN/Aadhaar Linked *"
          name={`applicants.${index}.panAadhaarLinked`}
          items={Object.keys(PAN_AADHAAR_MASTER).map((option) => ({
            label: PAN_AADHAAR_MASTER[option],
            value: option,
          }))}
        />
      </Grid>
    </>
  );
};

export default function AdditionalKYCDetails(): JSX.Element {
  const [kycDetails, setkycDetails] = useState(initialValues);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [brokerList, setBrokerList] = useState<BrokerList>();
  const { BrokerList } = useMdmsBrokerListData();
  const { toggler } = useFeatureToggles();
  const [dpbrokerList, dpsetBrokerList] = useState<DPNameType[]>([]);

  useEffect(() => {
    (async function () {
      try {
        setBrokerList(BrokerList as BrokerList);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [BrokerList]);

  useEffect(() => {
    const fetchBrokerList = async () => {
      try {
        const response = (await dispatch(getDPNameList())) as unknown as DPNameType[];
        dpsetBrokerList(response);
      } catch (e) {
        console.error((e as Error).message);
      }
    };

    fetchBrokerList();
  }, []);

  useEffect(() => {
    const { applicants: exisitingApplicants = [] } = application || {};
    setkycDetails({
      ...kycDetails,
      applicants: exisitingApplicants.map((applicant) => ({
        occupationDetails: applicant.occupationDetails || '',
        otherOccupationDetails: applicant.otherOccupationDetails || '',
        grossAnnualIncome: applicant.grossAnnualIncome || '',
        politicallyExposedPersonStatus: applicant.politicallyExposedPersonStatus
          ? applicant.politicallyExposedPersonStatus
          : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
          ? ''
          : 'Not Applicable',
        ckycNo: applicant.ckycNo || '',
        ckyc_selection_options: applicant.ckyc_selection_options || '',
        dlclId: applicant.dlclId ? applicant.dlclId : dlclIdFieldMandatory() ? '' : 'none',
        dpId: applicant.dpId || '',
        clId: applicant.clId || '',
        nameOfBroker: applicant.nameOfBroker || '',
        broker_id: applicant.broker_id || null,
        dematName: applicant.dematName || '',
        amcCallVerified: applicant.amcCallVerified || '',
        sourceOfFunds:
          applicant.sourceOfFunds && isOtherSourceOfFund(applicant.sourceOfFunds || '')
            ? 'others'
            : applicant.sourceOfFunds || '',
        otherSourceOfFunds: isOtherSourceOfFund(applicant.sourceOfFunds || '')
          ? applicant.sourceOfFunds
          : '',
        dataFetchedFromKRA: applicant.dataFetchedFromKRA || false,
        panAadhaarLinked: applicant.panAadhaarLinked || '',
      })),
    });
  }, [application]);

  const handleSubmit = async (values: Values) => {
    try {
      const { applicants, saveType } = values;
      const {
        applicants: exisitingApplicants = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        applicationNumber,
        createdAt = '',
        topupApplicationNumber,
      } = application || {};
      const updatedApplicants = exisitingApplicants.map((applicant, index) => {
        const {
          otherSourceOfFunds,
          // eslint-disable-next-line
          applicant_type,
          ...rest
        } = applicants[index];
        return {
          ...applicant,
          ...rest,
          clId: clearclIdField(applicants[index].dlclId || '', createdAt)
            ? ''
            : applicants[index].clId,
          dpId: cleardpIdField(applicants[index].dlclId || '')
            ? ''
            : applicants[index]?.dpId?.toUpperCase(),
          nameOfBroker: cleardpIdField(applicants[index].dlclId || '')
            ? ''
            : applicants[index].nameOfBroker,
          broker_id: cleardpIdField(applicants[index].dlclId || '')
            ? 0
            : applicants[index].broker_id,
          dematName: cleardpIdField(applicants[index].dlclId || '')
            ? ''
            : applicants[index].dematName,
          sourceOfFunds: isOtherSourceOfFund(applicants[index].sourceOfFunds || '')
            ? applicants[index].otherSourceOfFunds
            : applicants[index].sourceOfFunds,
          otherOccupationDetails: isOtherOccupation(applicants[index].occupationDetails || '')
            ? applicants[index].otherOccupationDetails
            : '',
        };
      });
      updatedApplicants.forEach((applicant, index) => {
        if (checkApplicantResident(applicant.status || '') && applicant.panAadhaarLinked === 'no') {
          throw `Pan/Aadhaar of ${getApplicantName(index + 1)} applicant is not linked`;
        }
      });

      const checkApplication = applicationComparison(application, {
        ...application,
        applicants: updatedApplicants,
        currentStep: !!currentStep && currentStep > 3 ? currentStep : Number(currentStep) + 1,
      });
      const isSaveLater = saveType !== 'save and proceed';
      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...application,
              applicants: updatedApplicants,
              status: statusRoleBased(role, application),
              currentStep: 4,
              //!!currentStep && currentStep > 3 ? currentStep : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );
        !isSaveLater
          ? history.push('fatca', {
              id,
              applicant1ReferenceId,
              topUpApplication: application?.isTopup,
            })
          : history.push(saveForLater(role, id, applicant1ReferenceId, application?.isTopup), {
              topUpApplication: application?.isTopup,
            });
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(
            `Application ${application?.isTopup ? topupApplicationNumber : applicationNumber} - ` +
              ' Saved successfully',
            {
              variant: 'success',
              autoHideDuration: 3000,
            }
          );
        }
        !isSaveLater
          ? history.push('fatca', {
              id,
              applicant1ReferenceId,
              topUpApplication: application?.isTopup,
            })
          : history.push(saveForLater(role, id, applicant1ReferenceId, application?.isTopup), {
              topUpApplication: application?.isTopup,
            });
      }
    } catch (e) {
      setLoading(false);
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={kycDetails}
      onSubmit={handleSubmit}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            KYCDetailsSchema(
              brokerList?.broker_list as Broker[],
              getOlderDate(application?.createdAt || '', application?.applicationCreatedAt || ''),
              toggler,
              application?.applicants as Partial<Applicant>[]
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues }) => (
        <Grid
          container
          rowSpacing={1}
          // columnSpacing={5}
          sx={{
            width: '100%',
            ml: 0,
            '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          {values.applicants.map((_, index) => (
            <KYCDetails
              applicant={getApplicantName(index + 1)}
              key={index}
              index={index}
              values={values}
              brokers={brokerList?.broker_list as Broker[]}
              ifTopUp={application?.isTopup || false}
              dpBroker={dpbrokerList}
            />
          ))}
          <ProceedSaveLater
            saveLater={() => {
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setValues({
                ...values,
                saveType: 'save and proceed',
              });
            }}
            loader={loading}
            clickedButton={values.saveType}
          />
        </Grid>
      )}
    </Formik>
  );
}
